import { ServiceCode } from '../enums/serviceCode';

export function getAnalystAllowedByServiceCode(code: ServiceCode) {
    return code === ServiceCode.TCOH;
}
